module.exports = __webpack_public_path__ + "img/setting.d717088b.png";